export const hy = {
  title: 'Արևադարձային վերգետնյա կենդանի փայտային կենսազանգվածի խտություն',
  subtitle: 'Tropics, Zarin/WHR',
  download_data: 'http://data.globalforestwatch.org/datasets/8f93a6f94a414f9588ce4657a39c59ff_1',
  content: [
    {
      label: 'Գործառույթ',
      value: 'Ցույց է տալիս վերգետնյա կենդանի փայտային կենսազանգվածի ածխածնի խտության արժեքները',
    },
    {
      label: 'Բանաձեւ',
      value: '30 մ',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Արևադարձային շրջաններ (30 աստիճան հյուսիսային, 20 աստիճան հարավ)',
    },
    {
      label: 'Աղբյուր',
      value: 'ICEsat GLAS lidar, MODIS, Landsat, հողային չափումներ',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '2000 թ',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'Ածխածնի խտության և անորոշության արժեքները խորհուրդ է տրվում միասին օգտագործել ածխածնի գնահատման և ստուգման համար: Քարտեզը կտրամադրի ածխածնի վերգետնյա պաշարների և վերգետնյա ածխածնի խտության ճշգրիտ գնահատականներ, երբ ագրեգացվում են մեծ տարածքներում (5000-ից մինչև 10000 հա)՝ ծրագրի և տարածաշրջանային մակարդակի գնահատման համար: Մեկ պիքսելի կենսազանգվածի խտության արժեքը կարող է մեծ անորոշություն ունենալ, երբ համեմատվում է ստուգման համար նախատեսված փոքր հողամասերի հետ:',
    },
    {
      label: 'Լիցենզիա',
      value: 'Creative Commons CC BY 4.0',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Սա ավելի բարձր լուծաչափով տվյալների արտադրանք է, որն ընդլայնվում է Baccini et al-ում ներկայացված մեթոդաբանության հիման վրա: (2012) ստեղծելու համար վերգետնյա կենդանի փայտային կենսազանգվածի խտության համաարևադարձային քարտեզը 30 մ լուծաչափով մոտ 2000 թվականի համար: Ածխածնի խտության արժեքների հետ մեկտեղ կա միևնույն տարածական լուծաչափով սխալի քարտեզ, որն ապահովում է վերգետնյա ածխածնի խտության գնահատման անորոշությունը: Այս քարտեզները թույլ են տալիս համատեղ տեղակայել կենսազանգվածի գնահատումները Հանսենի և այլոց հետ: (2013թ., v1.0) ծառերի ծածկույթի կորուստների գնահատումներ՝ նմանատիպ տարածական լուծաչափով: Վիճակագրական կապը, որը ստացվել է անտառային կենսազանգվածի խտության գետնի վրա հիմնված չափումների և համատեղ տեղակայված Geoscience Laser Altimeter System (GLAS) LiDAR ալիքի ձևաչափերի միջև, ինչպես նկարագրված է Baccini et al. (2012) օգտագործվել են արևադարձային տարածքներում ավելի քան 40,000 GLAS հետքերի կենսազանգվածի խտությունը գնահատելու համար: Այնուհետև, օգտագործելով պատահական Forest մոդելները, GLAS-ից ստացված կենսազանգվածի խտության գնահատումները փոխկապակցվեցին շարունակական, ցանցային փոփոխականների հետ, ներառյալ Landsat 7 ETM+ արբանյակային պատկերները և արտադրանքները (օրինակ՝ արտացոլումը), բարձրությունը և կենսաֆիզիկական փոփոխականները: Օգտագործելով շարունակական ցանցային տվյալների հավաքածուներ որպես մուտքեր պատահական անտառային մոդելների համար, ստեղծվել է արևադարձային տարածքներում վերգետնյա փայտային կենսազանգվածի խտության պատից պատ 30 մ լուծաչափով քարտեզ, ինչպես նաև հարակից անորոշության շերտ: Անորոշության շերտը հաշվի է առնում ալոմետրիկ հավասարումների, LiDAR-ի վրա հիմնված մոդելի և պատահական Forest մոդելի սխալները: Բոլոր սխալները տարածվում են մինչև կենսազանգվածի վերջնական գնահատականը: Աշխատանքի մանրամասն նկարագրությունը կներկայացվի պատրաստվող նոր փաստաթղթում:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Baccini A., W. Walker, L. Carvahlo, M. Farina, D. Sulla-Menashe, R. Houghton (2015): Արևադարձային անտառները ածխածնի զուտ աղբյուր են՝ հիմնված շահույթի և կորստի նոր չափումների վրա: Վերանայում. Մատչելի է Global Forest Watch Climate-ի միջոցով [date]: klima.globalforestwatch.org.',
  },
};
